import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=bc5f14ca&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=bc5f14ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5f14ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc5f14ca')) {
      api.createRecord('bc5f14ca', component.options)
    } else {
      api.reload('bc5f14ca', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=bc5f14ca&scoped=true&", function () {
      api.rerender('bc5f14ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2c2yJ42po6XX0/JS/comp/CookieBox.vue"
export default component.exports